export default __webpack_public_path__ + "static/media/location2.a5d458b1.png";